"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return S3;
    }
});
const _clients3 = require("@aws-sdk/client-s3");
const _libstorage = require("@aws-sdk/lib-storage");
const _GenericS3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/GenericS3/GenericS3"));
const _constants = require("~/constants");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let S3 = class S3 extends _GenericS3.default {
    get defaultParams() {
        return _extends({}, this.input.acl ? {
            ACL: this.input.acl
        } : {}, {
            Bucket: this.input.bucket
        });
    }
    patchKey(key) {
        if (!this.input.force_path_style) {
            return key;
        }
        if (_constants.S3_PATCH_KEYS.some((k)=>key.startsWith(`${this.input.bucket}/nc/${k}`))) {
            key = key.replace(`${this.input.bucket}/`, '');
        }
        return key;
    }
    async init() {
        var _this_input_force_path_style;
        const s3Options = {
            region: this.input.region,
            forcePathStyle: (_this_input_force_path_style = this.input.force_path_style) != null ? _this_input_force_path_style : false
        };
        if (this.input.access_key && this.input.access_secret) {
            s3Options.credentials = {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            };
        }
        if (this.input.endpoint) {
            s3Options.endpoint = this.input.endpoint;
        }
        this.s3Client = new _clients3.S3(s3Options);
    }
    async upload(uploadParams) {
        try {
            const upload = new _libstorage.Upload({
                client: this.s3Client,
                params: _extends({}, this.defaultParams, uploadParams)
            });
            const data = await upload.done();
            if (data) {
                const endpoint = this.input.endpoint ? new URL(this.input.endpoint).host : `s3.${this.input.region}.amazonaws.com`;
                if (this.input.force_path_style) {
                    return `https://${endpoint}/${this.input.bucket}/${uploadParams.Key}`;
                }
                return `https://${this.input.bucket}.${endpoint}/${uploadParams.Key}`;
            } else {
                _ncError.NcError._.storageFileCreateError('Upload failed or no data returned.');
            }
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(error.message);
        }
    }
    getUploadedPath(path) {
        const usePath = path.startsWith('/') ? path.replace(/$\/+/, '') : path;
        // TODO: more configurable urls, like using path-styles and CNAME
        // https://docs.aws.amazon.com/AmazonS3/latest/userguide/VirtualHosting.html
        return {
            url: `https://${this.input.bucket}.s3.${this.input.region}.amazonaws.com/${usePath}`
        };
    }
    constructor(input){
        super(input), this.name = 'S3';
    }
};
